{
  "companyRoles": {
    "owner": "Владелец",
    "member": "Сотрудник"
  },
  "projectRoles": {
    "producer": "Продюсер",
    "director": "Режиссёр",
    "member": "Участник",
    "viewer": "Наблюдатель",
    "support": "Поддержка"
  },
  "roleHints": {
    "company": {
      "owner": "все проекты, сотрудники, биллинг, задаёт лимиты расходов",
      "member": "только назначенные проекты"
    },
    "project": {
      "producer": "настройки, команда, архив",
      "director": "настройки без команды",
      "member": "только контент",
      "viewer": "только просмотр",
      "support": "просмотр и логи генераций"
    }
  },
  "people": {
    "you": "это вы",
    "allProjects": "Все проекты",
    "projectsAria": "Проекты: {{count}}",
    "shareMark": "Шара · {{company}}",
    "shareMarkAccess": "Шара · {{company}} · {{access}}",
    "active": {
      "yes": "Да",
      "no": "Нет"
    },
    "activity": {
      "title": "Активность за период",
      "allGenerations": "Все генерации",
      "usageJournal": "Журнал расходов",
      "perGeneration": "₽ за генерацию"
    },
    "projectsTable": {
      "project": "Проект",
      "company": "Компания",
      "role": "Роль",
      "since": "В проекте с",
      "generations": "Генерации",
      "spend": "Расход",
      "archived": "Архив",
      "notAssigned": "Не в проекте",
      "notAssignedHint": "Сейчас не в проекте, но за период были генерации"
    }
  },
  "shared": {
    "linkCopied": "Ссылка скопирована",
    "copyFailed": "Не удалось скопировать",
    "editingNow": "Сейчас редактируете",
    "email": "Email",
    "firstName": "Имя",
    "lastName": "Фамилия",
    "role": "Роль",
    "renewAndCopyLink": "Обновить и скопировать ссылку",
    "createInviteLink": "Создать ссылку",
    "createAndSendInvite": "Создать и отправить",
    "override": "override",
    "inherits": "наследует",
    "enabled": "Включено",
    "disabled": "Выключено",
    "setForCompany": "задан для компании",
    "passwordPlaceholderSet": "•••••• (оставьте пустым)",
    "saving": "Сохранение…"
  },
  "members": {
    "pageTitle": "Сотрудники",
    "headTitle": "Сотрудники компании",
    "tabs": {
      "members": "Сотрудники · {{count}}",
      "invitations": "Приглашения · {{count}}"
    },
    "filters": {
      "searchMembers": "Имя или email",
      "searchInvitations": "Email или имя",
      "roleAll": "Роль: все",
      "roleValue": "Роль: {{role}}",
      "projectAll": "Проект: все",
      "projects": "Проекты",
      "projectSearch": "Название проекта…",
      "archivedGroup": "Архив",
      "showDeactivated": "Показать деактивированных",
      "reset": "Сбросить",
      "resetFilters": "Сбросить фильтры",
      "statusAll": "Статус: все",
      "statusValue": "Статус: {{status}}"
    },
    "columns": {
      "person": "Сотрудник",
      "email": "Email",
      "role": "Роль",
      "projects": "Проекты",
      "activity": "Активность",
      "active": "Активный"
    },
    "footer": {
      "summary_one": "{{count}} сотрудник",
      "summary_few": "{{count}} сотрудника",
      "summary_many": "{{count}} сотрудников",
      "summary_other": "{{count}} сотрудника",
      "deactivatedTail_one": "ещё {{count}} деактивирован",
      "deactivatedTail_few": "ещё {{count}} деактивировано",
      "deactivatedTail_many": "ещё {{count}} деактивировано",
      "deactivatedTail_other": "ещё {{count}} деактивировано",
      "shown": "Показано {{shown}} из {{total}}",
      "roleFilter": "роль: {{role}}"
    },
    "empty": {
      "filteredTitle": "По этим фильтрам никого нет.",
      "filteredHint": "Попробуйте другую роль или проект — либо включите деактивированных.",
      "table": "Сотрудников нет."
    },
    "menu": {
      "open": "Открыть сбоку",
      "addToProject": "Добавить в проект",
      "makeOwner": "Сделать владельцем",
      "removeOwner": "Снять роль владельца",
      "deactivate": "Деактивировать",
      "activate": "Активировать",
      "remove": "Удалить из компании",
      "rowActions": "Действия"
    },
    "peek": {
      "close": "Закрыть",
      "open": "Открыть",
      "openHint": "Открыть страницу сотрудника",
      "copyLink": "Скопировать ссылку на карточку",
      "companyRole": "Роль в компании",
      "companyRoleHint": "Видит только проекты, на которые назначен. Владелец — все проекты, сотрудники и биллинг. Повышение до владельца и снятие роли владельца — с подтверждением.",
      "roleLock": {
        "self": "Свою роль изменить нельзя",
        "last_owner": "Единственный владелец",
        "deactivated": "Сначала активируйте сотрудника"
      },
      "projects": "Проекты · {{count}}",
      "addToProject": "Добавить в проект",
      "ownerSeesAll": "Видит все проекты",
      "ownerSeesAllHint": "Владелец видит все проекты, в том числе без роли в них.",
      "noProjects": "Назначений на проекты нет.",
      "projectMeta": "{{type}} · {{count}} в команде",
      "archivedMeta": "Архив · {{count}} в команде",
      "projectRoleAria": "Роль в проекте «{{project}}»",
      "removeFromProject": "Убрать из проекта",
      "details": "Сведения",
      "lastSeen": "Последняя активность",
      "joined": "В компании с",
      "joinedInvitedBy": "{{date}} · пригласил(а) {{name}}",
      "spendMonth": "Расход за месяц",
      "usageLink": "Журнал расходов",
      "spendLimit": "Лимит расходов",
      "spendLimitLine": "потрачено {{spent}} из {{limit}}",
      "spendLimitLeft": "осталось {{left}}",
      "spendLimitLeftResets": "осталось {{left}}, {{resets}}",
      "spendLimitNone": "Личного лимита нет — действуют только лимиты проектов и компании.",
      "spendLimitEmpty": "В этой компании лимиты расходов не действуют.",
      "deactivatedStatus": "Деактивировал(а) {{name}} · {{date}}. {{person}} не может войти в «{{company}}»; в списках виден(а) серым, роли и назначения сохранены.",
      "deactivatedStatusNoActor": "Деактивирован(а) {{date}}. {{person}} не может войти в «{{company}}»; в списках виден(а) серым, роли и назначения сохранены.",
      "activate": "Активировать",
      "deactivate": "Деактивировать",
      "remove": "Удалить из компании"
    },
    "dialogs": {
      "cancel": "Отмена",
      "close": "Закрыть",
      "quotedName": "«{{name}}»",
      "makeOwnerTitle": "Сделать {{name}} владельцем?",
      "makeOwnerIntro": "Владелец управляет всей компанией, а не отдельными проектами:",
      "makeOwnerPoint1": "видит все проекты, в том числе без роли в них",
      "makeOwnerPoint2": "приглашает и удаляет сотрудников, меняет роли",
      "makeOwnerPoint3": "видит биллинг и расход по каждому сотруднику",
      "makeOwnerPoint4": "меняет настройки компании",
      "makeOwnerAssignments": "Роли в проектах сохранятся:",
      "ownersWillBe_one": "Владельцев станет {{count}}.",
      "ownersWillBe_few": "Владельцев станет {{count}}.",
      "ownersWillBe_many": "Владельцев станет {{count}}.",
      "ownersWillBe_other": "Владельцев станет {{count}}.",
      "makeOwnerConfirm": "Сделать владельцем",
      "removeOwnerTitle": "Снять роль владельца с {{name}}?",
      "removeOwnerBody": "{{name}} станет сотрудником: потеряет доступ к сотрудникам, биллингу и настройкам компании.",
      "removeOwnerNoProjects": "Назначений на проекты нет — после смены роли проекты не будут видны, пока не добавят в команду.",
      "removeOwnerKeepsProjects": "Останется только в проектах, где у него есть роль:",
      "removeOwnerLastLeft": "Вы останетесь единственным владельцем.",
      "removeOwnerConfirm": "Снять роль владельца",
      "deactivateTitle": "Деактивировать {{name}}?",
      "deactivatePoint1": "не сможет войти в «{{company}}»; другие компании не затронуты",
      "deactivatePoint2": "останется в списках серым — в компании и в проектах",
      "deactivatePoint2Projects": "останется в списках серым — в компании и в {{list}}",
      "deactivatePoint3": "генерации, правки и расход сохранятся под именем",
      "deactivatePoint4": "получит письмо о деактивации",
      "deactivateReversible": "Вернуть доступ можно в любой момент кнопкой «Активировать».",
      "deactivateConfirm": "Деактивировать",
      "removeTitle": "Удалить {{name}} из компании?",
      "removeProjects": "будет снят(а) с проектов: {{list}}",
      "removeHistory": "история генераций и правок останется под именем",
      "removeEmail": "получит письмо об удалении",
      "removeInviteAgain": "Можно будет пригласить снова на тот же email. Если доступ нужно закрыть временно — деактивируйте.",
      "removeConfirm": "Удалить",
      "removeDeactivateInstead": "Деактивировать",
      "addToProjectTitle": "Добавить {{name}} в проект",
      "addToProjectCompany": "Компания",
      "addToProjectCompanyPlaceholder": "Выберите компанию",
      "addToProjectCompanySearch": "Найти компанию…",
      "addToProjectProject": "Проект",
      "addToProjectPlaceholder": "Выберите проект",
      "addToProjectSearch": "Найти проект…",
      "addToProjectSearchEmpty": "Ничего не найдено",
      "addToProjectRole": "Роль в проекте",
      "addToProjectEmpty": "Все активные проекты уже назначены.",
      "addToProjectConfirm": "Добавить",
      "removeFromProjectTitle": "Убрать {{name}} из проекта «{{project}}»?",
      "removeFromProjectBody": "Проект пропадёт из списка у {{name}}. Вернуть можно через «Добавить в проект».",
      "removeFromProjectBodyOwner": "У {{name}} снимется роль в проекте, доступ по роли владельца останется.",
      "removeFromProjectConfirm": "Убрать"
    },
    "invitations": {
      "ttlHint_one": "Ссылка действует {{count}} день · «Отправить ещё раз» продлевает срок и заменяет старую ссылку",
      "ttlHint_few": "Ссылка действует {{count}} дня · «Отправить ещё раз» продлевает срок и заменяет старую ссылку",
      "ttlHint_many": "Ссылка действует {{count}} дней · «Отправить ещё раз» продлевает срок и заменяет старую ссылку",
      "ttlHint_other": "Ссылка действует {{count}} дня · «Отправить ещё раз» продлевает срок и заменяет старую ссылку",
      "columns": {
        "invitee": "Приглашённый",
        "role": "Роль",
        "projects": "Проекты",
        "status": "Статус",
        "invitedBy": "Пригласил(а)"
      },
      "status": {
        "pending": "ожидает · до {{date}}",
        "pendingNoDate": "ожидает",
        "expired": "просрочено {{date}}",
        "accepted": "принято {{date}}",
        "declined": "отклонено {{date}}"
      },
      "statusFilter": {
        "pending": "ожидает",
        "expired": "просрочено",
        "accepted": "принято",
        "declined": "отклонено"
      },
      "notInCompany": "сейчас не в компании",
      "alreadyMember": "уже в компании",
      "history": "История",
      "invitedByLine": "{{name}} · {{date}}",
      "allProjects": "Все проекты",
      "resend": "Отправить ещё раз",
      "resendTitle": "Отправить приглашение ещё раз?",
      "resendBody": "Срок продлится до {{date}}. {{name}} получит новое письмо.",
      "resendWarning": "Старая ссылка из письма от {{date}} перестанет работать.",
      "resendWarningNoDate": "Старая ссылка из прежнего письма перестанет работать.",
      "resendConfirm": "Отправить ещё раз",
      "copyLink": "Скопировать ссылку",
      "copyLinkUnavailable": "Ссылка показывается сразу после отправки",
      "revoke": "Отозвать",
      "revokeTitle": "Отозвать приглашение для {{email}}?",
      "revokeBody": "Ссылка перестанет работать. Пригласить можно будет снова.",
      "revokeConfirm": "Отозвать",
      "inviteAgain": "Пригласить снова",
      "footerActive_one": "{{count}} активное",
      "footerActive_few": "{{count}} активных",
      "footerActive_many": "{{count}} активных",
      "footerActive_other": "{{count}} активных",
      "footerHistory": "{{count}} в истории",
      "emptyTitle": "Приглашений пока нет.",
      "emptyHint_one": "Ссылка из письма действует {{count}} день.",
      "emptyHint_few": "Ссылка из письма действует {{count}} дня.",
      "emptyHint_many": "Ссылка из письма действует {{count}} дней.",
      "emptyHint_other": "Ссылка из письма действует {{count}} дня.",
      "emptyFiltered": "По этим фильтрам приглашений нет."
    },
    "invite": {
      "button": "Пригласить",
      "title": "Пригласить в компанию",
      "titleProject": "Пригласить в «{{project}}»",
      "description_one": "Каждому адресу уйдёт письмо: кто пригласил, роль, проекты и ссылка. Ссылка действует {{count}} день.",
      "description_few": "Каждому адресу уйдёт письмо: кто пригласил, роль, проекты и ссылка. Ссылка действует {{count}} дня.",
      "description_many": "Каждому адресу уйдёт письмо: кто пригласил, роль, проекты и ссылка. Ссылка действует {{count}} дней.",
      "description_other": "Каждому адресу уйдёт письмо: кто пригласил, роль, проекты и ссылка. Ссылка действует {{count}} дня.",
      "descriptionProject_one": "Приглашённый войдёт в компанию «{{company}}» как сотрудник и сразу получит роль в этом проекте. Ссылка действует {{count}} день.",
      "descriptionProject_few": "Приглашённый войдёт в компанию «{{company}}» как сотрудник и сразу получит роль в этом проекте. Ссылка действует {{count}} дня.",
      "descriptionProject_many": "Приглашённый войдёт в компанию «{{company}}» как сотрудник и сразу получит роль в этом проекте. Ссылка действует {{count}} дней.",
      "descriptionProject_other": "Приглашённый войдёт в компанию «{{company}}» как сотрудник и сразу получит роль в этом проекте. Ссылка действует {{count}} дня.",
      "company": "Компания",
      "companyPlaceholder": "Выберите компанию…",
      "companySearch": "Найти компанию…",
      "companySearchEmpty": "Компания не найдена",
      "email": "Email",
      "emailHint": "Enter, запятая или пробел — следующий адрес. Можно вставить список.",
      "nameHint": "Подставится, когда человек примет приглашение.",
      "removeEmail": "Убрать {{email}}",
      "companyRole": "Роль в компании",
      "companyRoleHint": "Видит только проекты, на которые назначен. Владелец — все проекты, сотрудники и биллинг.",
      "projects": "Проекты",
      "optional": "необязательно",
      "projectSearch": "Найти проект…",
      "projectSearchEmpty": "Ничего не найдено",
      "projectsLoading": "Загружаем проекты…",
      "projectsFailed": "Не удалось загрузить проекты.",
      "projectsRetry": "Повторить",
      "archived": "архив",
      "projectOptionMeta": "{{type}} · {{count}}",
      "projectMeta": "{{type}} · {{count}} в команде",
      "projectRoleAria": "Роль в проекте «{{project}}»",
      "removeProject": "Убрать проект",
      "ownerSeesAll": "Владелец видит все проекты и без назначения. Роль в проекте можно выдать сразу.",
      "lockedRoleHint": "Роль компании назначает владелец. Приглашённый увидит только проекты, на которые назначен.",
      "lockedRoleReason": "Продюсер приглашает только сотрудников",
      "projectLockedTitle": "Проект",
      "otherProjectsHint": "Другие проекты назначит владелец компании со страницы «Сотрудники».",
      "errors": {
        "invalid": "{{email}} — похоже, адрес неполный",
        "duplicate": "{{email}} — адрес повторяется",
        "taken": "{{email}} — уже приглашён, отправьте приглашение ещё раз из списка",
        "already_member": "{{email}} — уже сотрудник компании",
        "already_member_deactivated": "{{email}} — сотрудник деактивирован, верните его кнопкой «Активировать»",
        "pending_exists": "{{email}} — на этот адрес уже есть приглашение в компанию",
        "unknown": "{{email}} — не удалось пригласить"
      },
      "errorsSummary": "Ничего не отправлено. Поправьте адреса с ошибкой или отправьте только остальные — роль и проекты сохранились.",
      "errorsFooter": "Адреса с ошибкой отправлены не будут",
      "tooMany_one": "Не больше {{count}} адреса за раз.",
      "tooMany_few": "Не больше {{count}} адресов за раз.",
      "tooMany_many": "Не больше {{count}} адресов за раз.",
      "tooMany_other": "Не больше {{count}} адреса за раз.",
      "submitEmpty": "Отправить приглашение",
      "submit_one": "Отправить {{count}} приглашение",
      "submit_few": "Отправить {{count}} приглашения",
      "submit_many": "Отправить {{count}} приглашений",
      "submit_other": "Отправить {{count}} приглашения",
      "cancel": "Отмена",
      "resultTitle_one": "Отправлено {{count}} приглашение",
      "resultTitle_few": "Отправлено {{count}} приглашения",
      "resultTitle_many": "Отправлено {{count}} приглашений",
      "resultTitle_other": "Отправлено {{count}} приглашения",
      "resultDescription": "Письма ушли от вашего имени. Если письмо не дошло — передайте ссылку вручную, она действует до {{date}}.",
      "resultAll": "Всем адресам:",
      "resultStatus": "ожидает · до {{date}}",
      "resultReplaced": "Заменило просроченное приглашение от {{date}} — старая ссылка больше не работает",
      "resultTabHint": "Приглашения видны на вкладке «Приглашения»: там можно отправить письмо ещё раз.",
      "copy": "Копировать",
      "copyAll": "Скопировать все ссылки",
      "inviteMore": "Пригласить ещё",
      "done": "Готово"
    },
    "linkCopied": "Ссылка скопирована",
    "copyFailed": "Не удалось скопировать",
    "page": {
      "headTitle": "{{name}} · сотрудник",
      "copyLink": "Скопировать ссылку на страницу",
      "joinedSince": "в компании с {{date}}",
      "invitedBy": "пригласил(а) {{name}}",
      "lastSeen": "последняя активность: {{when}}",
      "companyCanvas": "Холст компании",
      "rosterOwners": "Владельцы",
      "rosterMembers": "Сотрудники",
      "rosterDeactivated": "Деактивированные",
      "rosterEmpty": "Никого не найдено"
    }
  },
  "overview": {
    "title": "Обзор",
    "rename": "Переименовать",
    "slugHint": "Адрес компании (slug) задан при создании и не меняется — на него завязаны ссылки и письма.",
    "projects": "Проекты",
    "myProjects": "Мои проекты",
    "projectsInCompany": "в компании: {{count}}",
    "archivedCount": "{{count}} в архиве",
    "members": "Сотрудники",
    "deactivatedCount_one": "{{count}} деактивирован",
    "deactivatedCount_few": "{{count}} деактивировано",
    "deactivatedCount_many": "{{count}} деактивировано",
    "deactivatedCount_other": "{{count}} деактивировано",
    "allActive": "все активны",
    "generations": "Генерации",
    "running": "{{count}} в работе",
    "allTime": "за всё время",
    "owners": "Владельцы",
    "ownersMore": "{{name}} +{{count}}",
    "activity": "Активность за год",
    "avgPerDay": "в среднем {{amount}} в день"
  },
  "settings": {
    "pageTitle": "Настройки AI",
    "headTitle": "Настройки AI компании",
    "integrationsCount": "Интеграции · {{count}}",
    "connectionsHint": "Зелёный — у компании есть переопределение подключения.",
    "connectionCount": "{{count}} подключение",
    "connectionsHeading": "Подключения · {{count}}",
    "noConnections": "Нет подключений компании — наследуются глобальные значения.",
    "selectConnection": "Выберите подключение или создайте переопределение для компании.",
    "newConnectionTitle": "Новое подключение компании",
    "creatingOverride": "Создание переопределения",
    "globalInherited": "Глобальное значение (наследуется, если пусто)",
    "globalValue": "Глобально: {{value}}",
    "noGlobalConnection": "Нет глобального подключения для {{kind}}.",
    "inheritsGlobalCredentials": "наследует глобальные credentials",
    "passwordPlaceholderInheritGlobal": "наследует глобальные (оставьте пустым)",
    "overrideCount": "{{count}} override",
    "otherGroup": "Прочее",
    "googleGeminiTranscription": "Google Gemini · транскрипция",
    "saveSettings": "Сохранить настройки компании",
    "saveNote": "Сохраняются переопределения всех интеграций.",
    "noSettings": "Нет доступных настроек."
  },
  "models": {
    "pageTitle": "Модели",
    "headTitle": "Модели компании",
    "accessTitle": "Доступные модели",
    "defaultsTitle": "Модели по умолчанию",
    "defaultsHint": "Пустой пункт наследует модель платформы. Проект может заменить её у себя.",
    "inherit": "Как на платформе ({{name}})",
    "save": "Сохранить",
    "contexts": {
      "canvas_image": "Изображение",
      "canvas_video": "Видео"
    }
  },
  "systemPrompts": {
    "pageTitle": "Промпты",
    "headTitle": "Промпты компании",
    "companyOverrideLabel": "Переопределение компании (пусто = наследовать)",
    "placeholder": "Оставьте пустым, чтобы использовать глобальный промпт",
    "showGlobalPrompt": "Показать глобальный промпт",
    "saveOverrides": "Сохранить переопределения",
    "noTemplates": "Нет шаблонов в базе.",
    "filterPlaceholder": "Поиск по названию…",
    "clearFilter": "Очистить поиск",
    "filterEmpty": "Ничего не найдено."
  }
}
